//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import { ICONS } from "./Features.const";

export default {
    name: "FeatureDetails",
    components: {
        AQButton,
        AQDialog,
        AQToggle,
        FeatureCertSign: () => import(/* webpackChunkName: "FeatureCertSign" */ "./FeatureComponents/FeatureCertSign")
    },
    data() {
        return {
            defaultImage: require("@/assets/images/appDefault.svg"),
            hasImage: false,
            toggleValue: true,
            featureData: null,
            featureIcons: ICONS,
            showDialog: false
        };
    },
    computed: {
        getFeatureName() {
            return this.featureData ? this.featureData.name : "";
        }
    },
    created() {
        this.featureData = this.$route.params.featureData;
        this.$store.commit("main/setSaveBtnVisible", true);
    },
    methods: {
        /**
             * @description - set feature data and redirect to features main page
             * @param { Object } event - MouseEvent
             * @param { Boolean } value - (true / false) - feature toggle value - enabled / disabled
             */
        setFeatureData(event, value) {
            const returnFeatureData = {
                code: this.featureData.code,
                enabled: !!value,
                typeList: this.featureData.typeList,
                index: this.featureData.featureIndex
            };
            this.$router.push({ name: "FeaturesMainPage", params: { featureConfigData: returnFeatureData } });
        },
        /**
             * @description - method used on dialog return confirmation to features main page,
             *                action - "confirm" => return to features main page,
             *                action - "cancel" => remain on feature details configuration page
             * @param { String } action - values => "ok" / "cancel"
             */
        dialogConfirmAction(action) {
            if (action === "ok") {
                this.setFeatureData();
            }
            this.showDialog = false;
        },

        /**
             * @description - trigger on footer action buttons => save / cancel feature configutation
             * @param { String } actionSave - values => 'save' / 'cancel'
             */
        actionSaveOrCancel(actionSave) {
            if (actionSave === "save") {
                // emit event to current custom feature component - announce to save custom feature component data
                this.$root.$emit("saveFeatureData");
            } else {
                this.showDialog = true;
            }
        },
        /**
             * @description - event from custom feature component => set feature enabled and return to features main page
             */
        saveData() {
            this.setFeatureData(null, true);
        }
    }
};
